// "Pays N years, tax valid until year Y" for the renewal being priced.
// endYear is a Gregorian (ค.ศ.) year, 0 when there is no valid renewal yet;
// add 543 to show it as a Buddhist-era year. `result` is calculateCarTax's output.
export function taxRenewalPeriod(result) {
  const totals = result.totalTaxPrice;
  const endYear = Number(
    result.isActiveTaxYearEnd && totals[3] ? totals[3] : totals[1]
  );
  if (!(endYear > 0)) return { endYear: 0, yearCount: 0 };

  let yearCount = 1;
  if (result.lateAge > 36) yearCount = 4;
  else if (result.lateAge > 24) yearCount = 3;
  else if (result.lateAge > 12) yearCount = 2;
  return {
    endYear: endYear,
    yearCount: yearCount + (result.isActiveTaxYearEnd ? 1 : 0)
  };
}
